import { Navigate } from 'react-router'

import { useSession } from '@/features/auth/useSession'

/**
 * Where "/" goes.
 *
 * The portfolio is the right landing for anyone internal and a 404 for a guest,
 * whose reach is one project. Sending them to their boards means the first
 * screen after signing in is one they can actually see.
 */
export function Landing() {
  const session = useSession()

  if (session.isPending) return null

  return <Navigate to={session.data?.user.kind === 'guest' ? '/boards' : '/portfolio'} replace />
}
